import { constants } from '../constants';

export const setCacheService = ({ url, cacheName, responseData }) => {
  if (!url || !cacheName || !responseData) {
    console.error('Invalid parameters for caching data');
    return;
  }

  const fullCacheName = constants.PREFIX + cacheName;

  // Check for browser support
  if ('caches' in window) {
    caches.open(fullCacheName).then((cache) => {
      cache.put(url, responseData);
    });
  }
};
